import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import { HOME_URL, RESET_PASSWORD_URL } from '../../../const/URL.const';
import { useAuthenticationContext } from '../../../yoello-lib/modules/auth/AuthenticationContext';
import { useSnackbarMessages } from '../../../yoello-lib/modules/components/snackbar/SnackbarContext';
import useGenerateNavPath from "../../../hooks/useGenerateNavPath"
import { useCheckUserVerification } from '../util/useCheckUserVerification';

export function useForgotPasswordView() {
  useCheckUserVerification();
  const { forgotPasswordSendCode } = useAuthenticationContext();
  const [ isLoading , setIsLoading] = useState<boolean>(false);
  const { sendSnackbarMessage } = useSnackbarMessages()!;
  const history = useHistory();
  const { t }  = useTranslation();
  const { generateNavPath } = useGenerateNavPath();

  async function sendVerificationCode(data: any){
    const username = data.email.toLowerCase();
    setIsLoading(true);
    try {
      await forgotPasswordSendCode(username);
      sendSnackbarMessage(t("forms.forgotPassword.Texts.sendCodeSuccessful"),"success");
      history.push(generateNavPath(RESET_PASSWORD_URL,{
        username
      }));
      setIsLoading(false);
    } catch (error) {
      history.push(HOME_URL);
      sendSnackbarMessage(t("errors.formerrors.notfound"),"error");
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    sendVerificationCode
  }
}
